module.exports = __webpack_public_path__ + "img/2.ca37ef41.png";